export const offerChangeFields = [
  "releaseDate",
  "offerMappings",
  "effectiveDate",
  "countriesWhitelist",
  "publisherDisplayName",
  "id",
  "categories",
  "longDescription",
  "countriesBlacklist",
  "description",
  "viewableDate",
  "creationDate",
  "customAttributes",
  "seller",
  "refundType",
  "keyImages",
  "pcReleaseDate",
  "tags",
  "offerType",
  "urlSlug",
  "developerDisplayName",
  "items",
  "title",
  "productSlug",
  "lastModifiedDate",
];
